module.exports = __webpack_public_path__ + "static/ReviewUpload_files-984261e5b3d03eed557b728e74124fd4.png";